import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-document-upload-bottom-sheet',
    templateUrl: './document-upload-bottom-sheet.component.html',
    styleUrls: ['./document-upload-bottom-sheet.component.scss']
})
export class DocumentUploadBottomSheetComponent {
    constructor(
        private bottomSheetRef: MatBottomSheetRef<DocumentUploadBottomSheetComponent>
    ) {}
}
